<div id="settings-department-management" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH DEPARTMENTS -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <div class="row no-gutters mb-3">
                        <button id="{{idPrefix}}btn.create"
                                mat-flat-button
                                color="accent"
                                class="full-width"
                                (click)="new = true">
                            {{ 'department_management.btn.create' | translate | uppercase }}
                        </button>
                    </div>

                    <department-edit *ngIf="new"
                                     [idPrefix]="(idPrefix + 'new.')"
                                     [disabled]="disabled"
                                     (saved)="onSaveSuccess($event)"
                                     (canceled)="new = false">
                    </department-edit>

                    <!-- Below template is passed on to the action list to replace the default appearance -->
                    <ng-template #addOnDepartmentForm
                                 let-department="data">
                        <department-edit *ngIf="department.id === editId"
                                         [idPrefix]="(idPrefix + 'edit.')"
                                         [department]="department"
                                         [disabled]="disabled"
                                         (saved)="onSaveSuccess($event)"
                                         (canceled)="editId = null">
                        </department-edit>
                    </ng-template>

                    <action-list *ngIf="departmentList"
                                 [idPrefix]="idPrefix"
                                 [items]="departmentList.items"
                                 [options]="actionListOptions"
                                 [selected]="selectedDepartment"
                                 [identifier]="'id'"
                                 [addOn]="addOnDepartmentForm"
                                 (select)="selectDepartment($event)"
                                 (delete)="deleteDepartment($event)">
                    </action-list>

                    <div id="{{idPrefix}}btn.organigram"
                         class="btn-organigram mt-3 text-right"
                         (click)="openOrganigram()">
                        <i class="dr-fa-icon far fa-lg fa-file-pdf"></i>
                        <span class="ml-1">{{ 'department_management.btn.organigram' | translate }}</span>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH SELECTED DEPARTMENT -->


        <div class="col-sm-12 col-md-8">

            <mat-card>

                <mat-card-content>

                    <div class="row no-gutters mb-5" *ngIf="officeList && userList">
                        <div class="col-xs-12 col-sm-6">
                            <div class="row no-gutters">
                                <div class="col-sm-10">
                                    <div class="smp-title-thin-border">
                                        <span>{{ 'department_management.title.assigned_offices' | translate }}</span>
                                        <div class="routing-btn">
                                            <a id="{{idPrefix}}btn.office_management"
                                               class="iq-link-style"
                                               (click)="navigateTo('office-management')">
                                                {{ 'department_management.btn.office_management' | translate }}
                                            </a>
                                        </div>
                                    </div>

                                    <mat-list *ngIf="officeList">
                                        <mat-list-item *ngFor="let office of officeList.items"
                                                       class="office-or-user-item">
                                            {{ office.codeAndNames }}
                                        </mat-list-item>
                                    </mat-list>
                                </div>
                                <div class="col-sm-2">

                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <div class="row no-gutters">
                                <div class="col-sm-10">
                                    <div class="smp-title-thin-border">
                                        <span>{{ 'department_management.title.assigned_users' | translate }}</span>
                                        <div class="routing-btn">
                                            <a id="{{idPrefix}}btn.user_management"
                                               class="iq-link-style"
                                               (click)="navigateTo('user-management')">
                                                {{ 'department_management.btn.user_management' | translate }}
                                            </a>
                                        </div>
                                    </div>

                                    <mat-list *ngIf="userList">
                                        <mat-list-item *ngFor="let user of userList.items"
                                                       class="office-or-user-item">
                                            {{ user.lastname && user.firstname ? (user.lastname + ', ' + user.firstname) : (user.firstname ? user.firstname : (user.lastname ? user.lastname : '')) }}
                                        </mat-list-item>
                                    </mat-list>
                                </div>
                                <div class="col-sm-2">

                                </div>
                            </div>
                        </div>
                    </div>

                </mat-card-content>

            </mat-card>

        </div>

    </div>
</div>
